import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getTableColumnNames as getTableColumnNamesAPI, 
  ActiveDeactiveScore as ActiveDeactiveScoreAPI,
  GetAllScoresAPI,
  AddScoreAPI,
  UpdateScoreAPI,
  DeleteScoresAPI,
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Score Table Column Names
export const fetchScoreTableColumnNames = createAsyncThunk(
  "scores/fetchScoreTableColumnNames",
  async (params, thunkAPI) => { 
    try {
      const response = await getTableColumnNamesAPI(params); 
      return response.data;
    } catch (error) {
      toast.error(t("ErrorFetchingColumnNames"));
      return thunkAPI.rejectWithValue(error.response?.data || t("SomethingWentWrong"));
    }
  }
);

// Fetch All Scores
export const fetchAllScores = createAsyncThunk(
  "scores/fetchAllScores",
  async (params, thunkAPI) => { 
    try {
      const response = await GetAllScoresAPI(params);
      return response.data;
    } catch (error) {
      toast.error(t("ErrorFetchingScores"));
      return thunkAPI.rejectWithValue(error.response?.data || t("SomethingWentWrong"));
    }
  }
);

// Add Score
export const addScore = createAsyncThunk(
  "scores/addScore",
  async (scoreData, thunkAPI) => {
    try {
      const response = await AddScoreAPI(scoreData); 
      if (response.success) {
        toast.success(t(response.message));
        return response.data;
      } else {
        toast.error(t(response.message));
        return thunkAPI.rejectWithValue(response.message);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// // Update Score
export const updateScore = createAsyncThunk(
  "scores/updateScore", 
  async (scoreData, thunkAPI) => {
  try {
    const response = await UpdateScoreAPI(scoreData); 
    if (response.success) {
      toast.success(t(response.message));
      return response.data;
    } else {
      toast.error(t(response.message) );
      return thunkAPI.rejectWithValue(response.message);
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data);
  }
});

// Delete Scores
export const deleteScores = createAsyncThunk(
  "scores/deleteScores",
  async (scoreIds, thunkAPI) => { 
    try {
      const response = await DeleteScoresAPI({Ids:scoreIds});
      if (response.success) {
        toast.success(t(response.message));
        return scoreIds; 
      } else {
        toast.error(t(response.message));
        return thunkAPI.rejectWithValue(response.message);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// Activate/Deactivate Score
// export const activateDeactivateScore = createAsyncThunk(
//   "scores/activateDeactivateScore", 
//   async (scoreData, thunkAPI) => {
//     try {
//       const response = await ActiveDeactiveScoreAPI(scoreData); 
//       if (response.success) {
//         toast.success(t(response.message) || t("ScoreStatusUpdatedSuccessfully"));
//         return response.data; 
//       } else {
//         toast.error(t(response.message) || t("FailedToUpdateScoreStatus"));
//         return thunkAPI.rejectWithValue(response.message || t("FailedToUpdateScoreStatus"));
//       }
//     } catch (error) {
//       toast.error(t("ErrorUpdatingScoreStatus"));
//       return thunkAPI.rejectWithValue(error.response?.data || t("SomethingWentWrong"));
//     }
//   }
// );